import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import AuthShell from "./AuthShell";

export default function ForgotPasswordPage() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await forgotPassword(email.trim());
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <AuthShell
        title="Verifique seu e-mail"
        subtitle="Se este e-mail está cadastrado, você receberá um link para redefinir a senha em instantes."
        footer={<Link to="/login" className="auth-link" data-testid="link-to-login">Voltar para login</Link>}
      >
        <p className="text-center text-sm text-[#6B6B6B]" data-testid="forgot-sent">
          O link expira em 1 hora. Não viu na caixa de entrada? Cheque também a pasta de spam.
        </p>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      title="Esqueci minha senha"
      subtitle="Informe o e-mail cadastrado para receber o link de redefinição."
      footer={<Link to="/login" className="auth-link" data-testid="link-to-login">Voltar para login</Link>}
    >
      <form onSubmit={onSubmit} className="space-y-5" data-testid="forgot-form">
        <div>
          <label className="auth-label" htmlFor="email">E-mail</label>
          <input id="email" type="email" required autoComplete="email"
            value={email} onChange={(e) => setEmail(e.target.value)}
            className="auth-input" data-testid="forgot-email-input"/>
        </div>
        <button type="submit" disabled={loading} className="auth-cta" data-testid="forgot-submit-btn">
          {loading ? "Enviando…" : "Enviar link"}
        </button>
      </form>
    </AuthShell>
  );
}
